import React from "react";

import {
  DownloadFill,
  WalletFill as WalletIcon,
  Link as LinkIcon,
  HlLogo,
} from "@hl/base-components/lib/assets/icons.generated";
import {
  SECONDARY_COLOR,
  OUTLINE_COLOR,
} from "@hl/base-components/lib/theme/button";
import { Button, Group, Select } from "@mantine/core";
import useMantineMediaQueries from "~/../../base-components/lib/hooks/useMantineMediaQueries";

import { ReactComponent as HighlightLogo } from "assets/icons/highlight-logo.svg";

export type TabName =
  | "CONTRACT_TAB"
  | "WALLET_TAB"
  | "IMPORTED_TAB"
  | "CREATED_TAB"
  | "CREATED_OR_IMPORTED_TAB";

export type Props = {
  changeTab: (tab: TabName) => void;
  activeTab: TabName;
  showContractTab?: boolean;
  showWalletTab?: boolean;
  showImportedTab?: boolean;
  showCreatedTab?: boolean;
  showCreatedOrImportedTab?: boolean;
};

const SelectionMethodTabs = ({
  changeTab,
  activeTab,
  showContractTab,
  showWalletTab,
  showImportedTab,
  showCreatedTab,
  showCreatedOrImportedTab,
}: Props) => {
  const { isMedium } = useMantineMediaQueries();

  if (isMedium) {
    return (
      <Group mb="sm" noWrap spacing={8}>
        {showCreatedTab && (
          <Button
            sx={{
              border: "none",
            }}
            size="sm"
            px="sm"
            color={
              activeTab === "CREATED_TAB" ? SECONDARY_COLOR : OUTLINE_COLOR
            }
            onClick={() =>
              activeTab !== "CREATED_TAB" && changeTab("CREATED_TAB")
            }
            leftIcon={<HlLogo height={16} style={{ stroke: "none" }} />}
          >
            Created on Highlight
          </Button>
        )}
        {showImportedTab && (
          <Button
            sx={{
              border: "none",
            }}
            size="sm"
            px="sm"
            color={
              activeTab === "IMPORTED_TAB" ? SECONDARY_COLOR : OUTLINE_COLOR
            }
            onClick={() =>
              activeTab !== "IMPORTED_TAB" && changeTab("IMPORTED_TAB")
            }
            leftIcon={<DownloadFill height={16} />}
          >
            Imported
          </Button>
        )}
        {showCreatedOrImportedTab && (
          <Button
            sx={{
              border: "none",
            }}
            size="sm"
            px="sm"
            color={
              activeTab === "CREATED_OR_IMPORTED_TAB"
                ? SECONDARY_COLOR
                : OUTLINE_COLOR
            }
            onClick={() =>
              activeTab !== "CREATED_OR_IMPORTED_TAB" &&
              changeTab("CREATED_OR_IMPORTED_TAB")
            }
            leftIcon={<HighlightLogo height={16} />}
          >
            Created or Imported
          </Button>
        )}
        {showWalletTab && (
          <Button
            sx={{
              border: "none",
            }}
            size="md"
            px="sm"
            color={activeTab === "WALLET_TAB" ? SECONDARY_COLOR : OUTLINE_COLOR}
            onClick={() =>
              activeTab !== "WALLET_TAB" && changeTab("WALLET_TAB")
            }
            leftIcon={<WalletIcon height={16} />}
          >
            In your wallet
          </Button>
        )}
        {showContractTab && (
          <Button
            sx={{
              border: "none",
            }}
            size="sm"
            px="sm"
            color={
              activeTab === "CONTRACT_TAB" ? SECONDARY_COLOR : OUTLINE_COLOR
            }
            onClick={() =>
              activeTab !== "CONTRACT_TAB" && changeTab("CONTRACT_TAB")
            }
            leftIcon={<LinkIcon height={16} />}
          >
            By contract or URL
          </Button>
        )}
      </Group>
    );
  }

  return (
    <Select
      mt={-8}
      placeholder="Pick one"
      value={activeTab}
      onChange={(value) => changeTab(value as TabName)}
      data={
        [
          showCreatedTab && {
            value: "CREATED_TAB",
            label: "Created on Highlight",
          },
          showImportedTab && { value: "IMPORTED_TAB", label: "Imported" },
          showCreatedOrImportedTab && {
            value: "CREATED_OR_IMPORTED_TAB",
            label: "Created or Imported",
          },
          showWalletTab && { value: "WALLET_TAB", label: "In your wallet" },
          showContractTab && {
            value: "CONTRACT_TAB",
            label: "By contract or URL",
          },
        ].filter(Boolean) as unknown as { value: TabName; label: string }[]
      }
    />
  );
};

export default SelectionMethodTabs;
